export enum ButtonTheme {
  primary = 'PRIMARY',
  black = 'BLACK',
  outline = 'OUTLINE',
  white = 'WHITE',
}
